import React, { SyntheticEvent, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import {
  checkExtremeEl,
  checkLimitSelects,
  getLimits,
  TabType,
} from 'components/UI/StatisticsSelects/constants';
import { TooltipMapIcon } from 'components/UI/TooltipMapIcon';
import { setCurrentStatAction } from 'store/actions/mainPage';
import { getAteLayerAction, resetAteListAction } from 'store/actions/layers';
import { getText } from 'services/languageService';
import {
  Autocomplete,
  AutocompleteChangeReason,
  AutocompleteValue,
  Box,
  TextField,
} from '@mui/material';

export const StatAteLayers: React.FC<{ tabType: TabType }> = ({ tabType }) => {
  const { ateCities, ateVC, ateRegions } = useAppSelector(
    (state) => state.layers
  );
  const { currentAteRegions, currentAteCities, currentAteVC } = useAppSelector(
    (state) => state.mainPage
  );
  const dispatch = useAppDispatch();

  const handleChangeRegion = async (
    event: SyntheticEvent<Element, Event>,
    value: AutocompleteValue<any, any, any, any> | null,
    reason: AutocompleteChangeReason
  ) => {
    if (value.length) {
      const itemAll = value.find((item) => item.id === 'all');
      const withoutAll = value.filter((item) => item.id !== 'all');

      if (itemAll && checkExtremeEl(value, itemAll)) {
        dispatch(
          getAteLayerAction(
            'ateCities',
            {
              regions: [itemAll],
              cities: [],
              vc: [],
            },
            true
          )
        );
        dispatch(setCurrentStatAction('currentAteRegions', [itemAll])); //for check only all option
      } else {
        dispatch(
          getAteLayerAction(
            'ateCities',
            {
              regions: withoutAll,
              cities: [],
              vc: [],
            },
            true
          )
        );
        dispatch(setCurrentStatAction('currentAteRegions', withoutAll)); //for check another options
      }
    } else {
      dispatch(setCurrentStatAction('currentAteRegions', [])); //for reset
      dispatch(resetAteListAction('ateCities', 'currAteCity'));
      dispatch(resetAteListAction('ateVC', 'currAteVC'));
    }

    dispatch(setCurrentStatAction('currentAteCities', []));
    dispatch(setCurrentStatAction('currentAteVC', []));
  };

  const handleChangeCities = async (
    event: SyntheticEvent<Element, Event>,
    value: AutocompleteValue<any, any, any, any> | null,
    reason: AutocompleteChangeReason
  ) => {
    if (value.length) {
      const itemAll = value.find((item) => item.id === 'all');
      const withoutAll = value.filter((item) => item.id !== 'all');

      if (itemAll && checkExtremeEl(value, itemAll)) {
        dispatch(
          getAteLayerAction(
            'ateVC',
            {
              regions: currentAteRegions,
              cities: [itemAll],
              vc: [],
            },
            true
          )
        );
        dispatch(setCurrentStatAction('currentAteCities', [itemAll])); //for check only all option
      } else {
        dispatch(
          getAteLayerAction(
            'ateVC',
            {
              regions: currentAteRegions,
              cities: withoutAll,
              vc: [],
            },
            true
          )
        );
        dispatch(setCurrentStatAction('currentAteCities', withoutAll)); //for check another options
      }
    } else {
      dispatch(setCurrentStatAction('currentAteCities', []));
    }

    dispatch(setCurrentStatAction('currentAteVC', []));
  };

  const handleChangeVC = async (
    event: SyntheticEvent<Element, Event>,
    value: AutocompleteValue<any, any, any, any> | null,
    reason: AutocompleteChangeReason
  ) => {
    const itemAll = value.find((item) => item.id === 'all');
    const withoutAll = value.filter((item) => item.id !== 'all');

    if (value) {
      if (itemAll && checkExtremeEl(value, itemAll)) {
        dispatch(setCurrentStatAction('currentAteVC', [itemAll])); //for check only all option
      } else {
        dispatch(setCurrentStatAction('currentAteVC', withoutAll)); //for check another options
      }
    } else {
      dispatch(setCurrentStatAction('currentAteVC', []));
    }
  };

  const { disableCities, citiesTLcond, vcTLcond, disableVC } = getLimits(
    ateVC,
    ateCities,
    currentAteCities,
    currentAteRegions,
    tabType
  );

  useEffect(() => {
    checkLimitSelects(
      tabType,
      currentAteRegions,
      currentAteCities,
      currentAteVC,
      dispatch
    );
  }, []);

  return (
    <Box>
      <Autocomplete
        multiple
        limitTags={1}
        disableListWrap
        value={currentAteRegions}
        id="controllable-states-demo"
        size="small"
        fullWidth
        options={ateRegions}
        onChange={handleChangeRegion}
        sx={{ mb: 1, mt: 1 }}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.name}
            </li>
          );
        }}
        renderInput={(params) => (
          <TextField label={getText('ATE_REGIONS')} {...params} />
        )}
      />
      <TooltipMapIcon
        placement="right"
        title={citiesTLcond ? getText('DIS_STAT_CITIES_TL') : ''}
      >
        <Autocomplete
          value={currentAteCities}
          multiple
          limitTags={1}
          disableListWrap
          id="controllable-states-demo"
          size={'small'}
          fullWidth
          options={ateCities}
          onChange={handleChangeCities}
          sx={{ mb: 1 }}
          disabled={disableCities}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.id}>
                {option.name}
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField label={getText('ATE_CITIES')} {...params} />
          )}
        />
      </TooltipMapIcon>

      <TooltipMapIcon
        placement="right"
        title={vcTLcond ? getText('DIS_STAT_VC_TL') : ''}
      >
        <Autocomplete
          value={currentAteVC}
          multiple
          limitTags={1}
          disableListWrap
          id="controllable-states-demo"
          size={'small'}
          fullWidth
          options={ateVC}
          onChange={handleChangeVC}
          disabled={disableVC}
          sx={{ mb: 1 }}
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.id}>
                {option.name}
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField label={getText('ATE_VC')} {...params} />
          )}
        />
      </TooltipMapIcon>
    </Box>
  );
};
